import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function GuaranteeSection() {
  return <section className="py-10 md:py-20 px-4 bg-brand-guarantee border-y-4 border-brand-green" data-id="element-154">
      <div className="max-w-4xl mx-auto text-center" data-id="element-155">
        <ShieldCheckIcon className="w-16 h-16 md:w-24 md:h-24 text-brand-green mx-auto mb-4 md:mb-6" data-id="element-156" />

        <h2 className="text-3xl md:text-5xl font-black text-brand-dark mb-6 md:mb-8 uppercase" data-id="element-157">
          🛡️ GARANTÍA FÍSICA EN ACCIÓN — 7 DÍAS
        </h2>

        <div className="text-lg md:text-2xl text-gray-800 space-y-3 md:space-y-4 font-medium mb-8 md:mb-12 max-w-3xl mx-auto" data-id="element-158">
          <p data-id="element-159">Descargás los materiales. Los abrís. Los revisás.</p>
          <p className="font-bold text-brand-dark" data-id="element-160">
            Si sentís que no te ahorran horas de trabajo o no se adaptan a tu
            aula argentina:
          </p>
          <p className="text-3xl font-black text-brand-green py-4" data-id="element-161">
            Te devolvemos el 100% de tu dinero.
          </p>
          <p data-id="element-162">Sin preguntas. Sin vueltas. Tu inversión está protegida.</p>
        </div>

        <div className="max-w-xl mx-auto" data-id="element-163">
          <CTAButton text="→ EMPEZAR HOY CON GARANTÍA" href="#compra" data-id="element-164" />
        </div>
      </div>
    </section>;
}